var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoaded)?_c('PowerBI',{attrs:{"user-profile-department-ids":_vm.userProfileDepartmentIds}}):_vm._e(),_c('URLEmbedCharts',{attrs:{"user-profile-department-ids":_vm.userProfileDepartmentIds}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }